module.exports = __webpack_public_path__ + "static/media/send_grey.cb118cf9.svg";